import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Button from '../../Elements/Button/Button';
import TemplateParser from '../TemplateParser';
import { preloadPage } from '../../../actions/environment';
import { purifier } from '../../../utils/dom';
import { translate, prefix } from '../../../utils/locale';
import { urlify } from '../../../utils/string';
import s from './Wash.scss';

const Wash = ({ productCache, pageData, content, setup, ...props }) => {
	const [currentWash, toggleWash] = useState(false);
	const [showProduction, toggleProduction] = useState(false);
	if (!productCache?.[setup.market]?.[setup.pricelist]?.filterDescriptions || content.fabrics.length === 0) return true;
	const { washes } = productCache[setup.market][setup.pricelist].filterDescriptions;

	const toggleWashHandler = (e) => {
		e.preventDefault();
		const selectedWash = e.currentTarget.getAttribute('href').slice(13);
		const [whichFabric, washUrlified] = selectedWash.split('_');
		toggleProduction(false);
		toggleWash((prevState) => (selectedWash !== prevState ? selectedWash : ''));

		const whichWash = content.fabrics[whichFabric].washes.filter((wash) => urlify(wash.name) === washUrlified);
		const preloadPages = [];
		if (whichWash[0].production) {
			whichWash[0].production.forEach((p) => preloadPages.push(p.uri[setup.language]));
			props.preloadPage(preloadPages);
		}
	};

	const productionExpandHandler = (e) => {
		e.preventDefault();
		toggleProduction((prevState) => !prevState);
	};

	return (
		<div className={s.fabrics}>
			{
				content.fabrics.map((fabric, i) => (
					<div className={s.fabric}>
						<h6 className={s.fabric_title}>{ translate(setup, fabric.title) }</h6>
						<div className={s.fabric_description} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, fabric.description)) }} />
						<div className={s.washes}>
							{
								fabric?.washes && fabric.washes.map((wash) => {
									const washUrlified = urlify(wash.name);
									if (!washes[washUrlified]) return null;
									return (
										<div className={[s.wash, currentWash === `${i}_${washUrlified}` ? s.wash__expanded : null].join(' ')}>
											<a className={s.wash_header} href={`#expand-wash-${i}_${washUrlified}`} onClick={toggleWashHandler}>
												<span className={s.wash_header_inner}>
													<img src={washes[washUrlified].image.url} alt="" width="56" loading="lazy" />
													<span className={s.wash_header_inner_title}>{ wash.name }</span>
												</span>
											</a>
											<div className={s.wash_content}>
												<div className={s.wash_content_description} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, wash.description)) }} />
												{
													wash.production && wash.production.map((p) => {
														if (!p.uri[setup.language]) return null;
														if (!showProduction) {
															return (
																<div key={p.uri[setup.language]} className={s.wash_content_production}>
																	<Link className={s.wash_content_production_link} to={`${prefix(setup, '/')}${p.uri[setup.language]}`} onClick={productionExpandHandler}>{ translate(setup, 'fabricProduction') }</Link>
																</div>
															);
														}
														if (showProduction && pageData?.[p.uri[setup.language]]?.content?.sections) {
															return (
																<div key={p.uri[setup.language]} className={s.wash_content_production}>
																	<Link className={s.wash_content_production_link} to={`${prefix(setup, '/')}${p.uri[setup.language]}`} onClick={productionExpandHandler}>{ translate(setup, 'fabricProduction') }</Link>
																	<TemplateParser sections={pageData[p.uri[setup.language]].content.sections} setup={setup} />
																</div>
															);
														}
														return null;
													})
												}
											</div>
										</div>
									);
								})
							}
						</div>
					</div>
				))
			}
			<div className={s.fabrics_footer}>
				<div className={s.fabrics_footer_inner}>
					{
						!currentWash ? (
							<Button variantClasses={['button__blue']} type="button" disabled>{ translate(setup, 'fabricSelect') }</Button>
						) : (
							<Button variantClasses={['button__blueInverse']} type="link" location={`${prefix(setup, '/')}woman#washes=${currentWash.slice(currentWash.lastIndexOf('_') + 1)}`}>
								<span>{ translate(setup, 'fabricView') }</span>
								<span>{ translate(setup, 'fabricItemsIn').replace('%wash%', (washes?.[currentWash.slice(currentWash.lastIndexOf('_') + 1)]?.text || '')) }</span>
							</Button>
						)
					}
				</div>
			</div>
		</div>
	);
};

const mapState = ({ productCache, pageData }, props) => ({ productCache, pageData, ...props });

export default hot(module)(connect(mapState, { preloadPage })(Wash));
